// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__UCYFl","requiredAsterisk":"Info_requiredAsterisk__2p-uE"};